// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productAddToListLinkStyles } from "@conklin/Overrides/Components/ProductAddToListLink";
import IconAddProject from "@conklin/XDL/Icons/IconAddProject";
import { color, createLinkIconStyles } from "@conklin/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

productAddToListLinkStyles.link = createLinkIconStyles(IconAddProject, "small");

productAddToListLinkStyles.button = {
    variant: "secondary",
    sizeVariant: "small",
    icon: {
        src: IconAddProject,
        position: "left",
    },
    css: css`
        padding: 8px 10px;
        ${IconWrapper} {
            margin: 0;
            &,
            svg {
                color: ${color("common.ui8")};
                width: 10px;
                height: 14px;
            }
        }
    `,
};
